import ModelUtil from '@leverege/model-util';
import { FontModel } from '@leverege/ui-style-elements';

/**
 * This is meant to help out and supply a common model
 * for Detail Models that have a label and a value that
 * is displayed as a string. It supplies style options
 * for the label and value, as well as controls to
 * hide label and what to show when the value is null
 */
function create(type, extend) {
  return {
    type,
    visible: true,
    label: {
      name: null,
      visible: true,
      color: null,
      variant: null,
      font: FontModel.create(),
      justify: 'left',
      align: 'center',
      wrap: false
    },
    value: {
      color: null,
      variant: null,
      font: FontModel.create(),
      justify: 'right',
      align: 'center',
      wrap: false,
      showIfEmpty: true,
      visible: {
        type: 'visibilizer.IfEmpty',
        value: true
      },
      emptyValue: '-'
    },
    columns: 2,
    ...extend
  };
}
export default {
  create,
  // ...ModelUtil.createAllValue( 'visible' ),
  ...ModelUtil.createAllValue('label/name', 'label'),
  ...ModelUtil.createAllValue('label/visible', 'labelVisible'),
  ...ModelUtil.createAllValue('label/color', 'labelColor'),
  //
  ...ModelUtil.createAllValue('label/variant', 'labelVariant'),
  //
  ...ModelUtil.createAllValue('label/font', 'labelFont'),
  //
  ...ModelUtil.createAllValue('label/justify', 'labelJustify'),
  //
  ...ModelUtil.createAllValue('label/align', 'labelAlign'),
  //
  ...ModelUtil.createAllValue('label/wrap', 'labelWrap'),
  //

  ...ModelUtil.createAllValue('value/showIfEmpty', 'showIfEmpty'),
  ...ModelUtil.createAllValue('value/emptyValue', 'emptyValue'),
  ...ModelUtil.createAllValue('value/color', 'valueColor'),
  //
  ...ModelUtil.createAllValue('value/variant', 'valueVariant'),
  //
  ...ModelUtil.createAllValue('value/font', 'valueFont'),
  //
  ...ModelUtil.createAllValue('value/justify', 'valueJustify'),
  //
  ...ModelUtil.createAllValue('value/align', 'valueAlign'),
  //
  ...ModelUtil.createAllValue('value/wrap', 'valueWrap'),
  //

  ...ModelUtil.createAllValue('background'),
  ...ModelUtil.createAllValue('value/visible', 'valueVisible'),
  getValueVisible(model) {
    if (model?.value?.visible != null) {
      return model.value.visible;
    }
    return {
      type: 'visibilizer.IfEmpty',
      value: model?.value?.showIfEmpty
    };
  }
};